import { createSlice, createSelector } from '@reduxjs/toolkit';
import {fetchGptResponse} from "../../api/inferenceApi";


const gptApiSlice = createSlice({
    name: 'gptApi',
    initialState: {
        responses: {}, // Use an object keyed by UUID
        status: 'idle',
        error: null
    },
    reducers: {
        clearResponses: (state) => {
            state.responses = {};
        },
        removeResponseById: (state, action) => {
            delete state.responses[action.payload];
        },
        updateResponseById: (state, action) => {
            const { id, data } = action.payload;
            if (state.responses[id]) {
                state.responses[id].data = data;
                // Optionally update the timestamp or any other relevant metadata
                state.responses[id].timestamp = new Date().toISOString();
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGptResponse.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGptResponse.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.responses[action.payload.id] = action.payload;
            })
            .addCase(fetchGptResponse.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

const selectResponses = state => state.gptApi.responses;

export const selectResponseById = createSelector(
  [selectResponses, (state, responseId) => responseId],
  (responses, responseId) => responses[responseId]
);

export const { clearResponses, removeResponseById, updateResponseById } = gptApiSlice.actions;
export default gptApiSlice.reducer;